import {Injectable} from "@angular/core";
import {Picture} from "../../model/picture";
import {Subject} from "rxjs/Rx";
import {UrlService} from "../url.service";
import {CurrentEventService} from "./currentEventService";

@Injectable()
export class FileUploaderService {

  private pictureAddSource = new Subject<UploadedPicture>();

  private showSource = new Subject<string>();

  private reloadSource = new Subject<string>();

  pictureAdded$ = this.pictureAddSource.asObservable();

  showChanged$ = this.showSource.asObservable();

  reloadChanged$ = this.reloadSource.asObservable();

  constructor(private urlService:UrlService, private currentEvent:CurrentEventService) {

  }

  upload() {
    this.showSource.next('upload');
  }

  show() {
    this.showSource.next('show');
  }

  hide() {
    this.showSource.next('hide');
  }

  minimize() {
    this.showSource.next('minimize');
  }

  addPicture(response:string, eventId: number) {
    let picture:UploadedPicture = JSON.parse(response);
    picture.eventId = eventId;

    this.pictureAddSource.next(this.setUrls(picture));
  }

  reloadPage() {
    this.reloadSource.next();
  }

  private setUrls(picture:UploadedPicture):UploadedPicture {
    if(this.currentEvent.currentEvent!=null) {
      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.currentEvent.currentEvent.id, picture.id);
      picture.url = this.urlService.getPictureUrl(this.currentEvent.currentEvent.id, picture.id);
    }

    return picture;
  }

}

export class UploadedPicture extends Picture {
  eventId: number;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/communication/fileUploaderService.ts